import {
  CommandListNetworkResources,
  NetworkResourceListFilters,
} from "./commands/cmdListNetworkResources";

import { CommandStartOAuthFlow } from "./commands/cmdStartOAuthFlow";
import { CommandGetOAuthUrl } from "./commands/cmdGetOAuthUrl";
import { CommandDeleteNetworkResource } from "./commands/cmdDeleteNetworkResource";
import { CommandCreateNetworkResource } from "./commands/cmdCreateNetworkResource";
import { NetworkResource } from "@models/networkResource";
import { CommandUpdateNetworkResource } from "./commands/cmdUpdateNetworkResource";
import { CommandLinkNetworkResource } from "./commands/cmdLinkNetworkResource";
import { CommandUnlinkNetworkResource } from "./commands/cmdUnlinkNetworkResource";
import { CommandGetSubresources, NetworkSubresources } from "./commands/cmdGetSubresources";
import { CommandCheckConnection, CheckConnectionResponse } from "./commands/cmdCheckConnection";

export class NetworkAccountService {
  async listNetworkResources(
    filters: NetworkResourceListFilters,
  ): Promise<NetworkResource[]> {
    const cmd = new CommandListNetworkResources();
    return await cmd.run(filters);
  }

  async updateNetworkResource(
    resourceId: number,
    data: Partial<NetworkResource>,
  ): Promise<NetworkResource> {
    const cmd = new CommandUpdateNetworkResource();
    return await cmd.run(resourceId, data);
  }

  async createNetworkResource(data: NetworkResource): Promise<NetworkResource> {
    const cmd = new CommandCreateNetworkResource();
    return await cmd.run(data);
  }

  async deleteNetworkResource(resourceId: number): Promise<void> {
    const cmd = new CommandDeleteNetworkResource();
    await cmd.run(resourceId);
  }

  async startOAuthFlow(accountId: number) {
    const cmd = new CommandStartOAuthFlow();
    return await cmd.run(accountId);
  }

  async getOAuthUrl(resourceId: number): Promise<{ auth_url: string }> {
    const cmd = new CommandGetOAuthUrl();
    return await cmd.run(resourceId);
  }

  async linkNetworkResource(childId: number, parentId: number) {
    const cmd = new CommandLinkNetworkResource();
    return await cmd.run(childId, parentId);
  }

  async unlinkNetworkResource(childId: number, parentId: number) {
    const cmd = new CommandUnlinkNetworkResource();
    return await cmd.run(childId, parentId);
  }

  async getSubresources(resourceId: number): Promise<NetworkSubresources> {
    const cmd = new CommandGetSubresources();
    return await cmd.run(resourceId);
  }

  async checkConnection(resourceId: number): Promise<CheckConnectionResponse> {
    const cmd = new CommandCheckConnection();
    return await cmd.run(resourceId);
  }
}
